import type { Mission } from '../missions.ts'

export const dod: Mission = {
  id: 'dod',
  name: 'Department of War',
  short: 'DOW',
  call: "War",
  kind: 'department',
  url: 'https://www.war.gov/',
  established: 1947,
  palette: { primary: '#355e93', secondary: '#002169', accent: '#ffcd00' },
  colorSource: { kind: 'brand-guide', url: 'https://www.war.gov/Brand-Guide/' },
  motif: 'eagle',
  mission: {
    text: "Our mission is to provide the military forces needed to deter war and ensure our nation's security.",
    url: 'https://www.war.gov/About/',
  },
  fact: {
    text: 'Founded in 1947 as the National Military Establishment, it took the Department of Defense name in 1949.',
    url: 'https://www.history.com/articles/department-of-war-defense-name-changes',
  },
  seal: {
    file: 'public/seals/dod.png',
    source: 'https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_War_(2025).svg',
  },
  logo: {
    file: 'public/logos/dod.svg',
    source: 'https://commons.wikimedia.org/wiki/File:United_States_Department_of_War_Logo_(2025,_Small_Use).svg',
  },
  media: {
    photos: [
        {
          file: "/media/dod-pentagon.jpg",
          small: "/media/dod-pentagon-sm.jpg",
          alt: "Aerial view of the Pentagon's five rings and central courtyard, with the Potomac River and Washington beyond.",
          title: "Aerial view of the Pentagon, May 11, 2021",
          creator: "Staff Sgt. Brittany A. Chase, U.S. Air Force, Department of Defense",
          source: "https://commons.wikimedia.org/wiki/File:Aerial_Closeup_of_the_Pentagon,_May_11,_2021.jpg",
          license: "Public domain (U.S. government work)",
        },
        {
          file: "/media/dod-carrier-sunset.jpg",
          small: "/media/dod-carrier-sunset-sm.jpg",
          alt: "An aircraft carrier in silhouette against an orange sunset sky over the Pacific Ocean.",
          title: "USS George Washington (CVN 73) underway at sunset, Pacific Ocean, September 8, 2012",
          creator: "Mass Communication Specialist 3rd Class Paul Kelly, U.S. Navy",
          source: "https://commons.wikimedia.org/wiki/File:Stern_view_of_USS_George_Washington_(CVN-73)_in_the_Pacific_Ocean_at_sunset_120908-N-TX154-113.jpg",
          license: "Public domain (U.S. government work)",
        },
    ],
  },
}
